import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect } from "react";
import { any, propEq } from "ramda";
import { useLocation } from "react-router-dom";
import { useMatomo } from "@datapunt/matomo-tracker-react";
import UnAuthenticatedApp from "routes/UnAuthenticatedApp";
import AuthenticatedApp from "routes/AuthenticatedApp";
import { useAuthContext } from "@authentication/context";
import { jsx as _jsx } from "react/jsx-runtime";
export default function App(props) {
  var _useAuthContext = useAuthContext(),
    getUser = _useAuthContext.getUser;
  var location = useLocation();
  var _useMatomo = useMatomo(),
    trackPageView = _useMatomo.trackPageView;
  var user = getUser();
  useEffect(function () {
    if (!location.pathname.includes("/admin")) trackPageView();
  }, [location.pathname, trackPageView]);
  return user !== null && user !== void 0 && user.ticket && any(propEq("hasAccess", true), (user === null || user === void 0 ? void 0 : user.resources) || []) ? /*#__PURE__*/_jsx(AuthenticatedApp, _objectSpread({}, props)) : /*#__PURE__*/_jsx(UnAuthenticatedApp, _objectSpread({}, props));
}